import React from 'react';
const kennitala = require('kennitala')
import { formatKennitala, Spinner, formatMoney, getUrlParam } from '../../utils'
import { gettext } from '../../locale'
import moment from 'moment'
import { Bar } from 'react-chartjs-2';
import OfferTable from '../offer-table'


const ContractLine = (props) => {
    return (
        <tr className={`${props.type === "main"?"":props.type}`}>
            <td>
            <strong>{gettext(props.name)}</strong> {gettext(props.name, 'de') !== "" && <>({gettext(props.name, 'de')})</>} {props.extraText}
            </td>
            { props.noAmount ? 
                <td className="text-right nowrap">
                    {props.noAmountText}
                </td>
                :
                <>
                    { props.currencyExchange ?
                        <td className="text-right nowrap">
                            {formatMoney(props.value*props.currencyExchange, props.iskDecimals)} kr. ({formatMoney(props.value, props.eurDecimals)} €)
                        </td>
                        :
                        <td className="text-right nowrap">
                            {formatMoney(props.value)} €
                        </td>
                    }
                </>
            }
     </tr>  
    )
}
ContractLine.defaultProps = {
    noAmount: false,
    noAmountText: "Ekki valið",
    type: "main",
    eurDecimals: 0,
    iskDecimals: 0,
    extraText: ""
}

export default ContractLine